import React from 'react';

/**
 * Renders a message string; if it contains newlines, displays each non-empty line as a list item for readability.
 */
export const ValidationErrorDisplay: React.FC<{ message: string }> = ({ message }) => {
  const lines = message
    .split(/\r?\n/)
    .map((l) => l.trim())
    .filter((l) => l.length > 0);
  if (lines.length > 1) {
    return (
      <ul className="mb-0 ps-3">
        {lines.map((line) => (
          <li key={line}>{line}</li>
        ))}
      </ul>
    );
  }
  return <>{message}</>;
};
